import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { ClientProductSummary, CreateProductRequest, Options, Product } from "../../types/product";
// import { AddOns } from "../../types/oddons";
import { OrderOption } from "../../types/order";
import { initialProductState, initialSelectedSize } from "../../initial-state/initial-state";
import { AddOnsData } from "../setup/setupResponse";

export interface CreateProductBody {
    category: Options | null;
    productName: string;
    price: number; 
    size: Options | null;
    image: string;
    isAvailable: boolean;
    type: Options | null; 
    addOns: AddOnsData[] | null;
    description: string;
    productID: number | null 
    isOutOfStock: boolean 
}

interface ProductState {
    newProduct: CreateProductBody;
    selectedProduct: Product | null;
    selectedProductToAddQty: ClientProductSummary | null;
    selectedSize: OrderOption;
}

const initialState: ProductState  = {
    newProduct: initialProductState,
    selectedProduct: null,
    selectedProductToAddQty: null,
    selectedSize: initialSelectedSize,
};

const userSlice = createSlice({
    name: 'product',
    initialState,
    reducers: {
        setSelectedSize: (state, action: PayloadAction<OrderOption>) => {
            state.selectedSize = action.payload;
        },
        clearSelectedSize: (state) => {
            state.selectedSize = { id: 0, name: 'All'}
        },

        setSelectedProduct: (state, action: PayloadAction<Product | null>) => {
            state.selectedProduct = action.payload;
        },
        clearSelectedProduct: (state) => {
            state.selectedProduct = null;
        },
        // setSelectedProductToAddQty: (state, action: PayloadAction<ProductSummary | null>) => {
        setSelectedProductToAddQty: (state, action: PayloadAction<ClientProductSummary | null>) => {
            state.selectedProductToAddQty = action.payload;
        },
        clearSelectedProductToAddQty: (state) => {
            state.selectedProductToAddQty = null;
        },

        setPopulateNewProduct: (state, action: PayloadAction<CreateProductBody>) => {
            state.newProduct = action.payload;
        },
        updateNewProduct: (
            state,
            action: PayloadAction<Partial<CreateProductBody>>
        ) => {
            state.newProduct = {
                ...state.newProduct,
                ...action.payload,
            };
        },
        toggleAddOn: (state, action: PayloadAction<AddOnsData>) => {
            const selectedAddOn = action.payload;

            if (!state.newProduct.addOns) {
                state.newProduct.addOns = [selectedAddOn];
                return;
            }

            const index = state.newProduct.addOns.findIndex(
                (item) => item.addonID === selectedAddOn.addonID
            );

            if (index !== -1) {
                // Already selected → remove it
                state.newProduct.addOns.splice(index, 1);
            } else {
                // Not selected → add it
                state.newProduct.addOns.push(selectedAddOn);
            }
        },
        resetNewProduct: (state) => {
            state.newProduct = {
                category: null,
                productName: '',
                description: '',
                price: 0,
                size: null,
                image: '',
                type: null,
                addOns: null,
                isAvailable: false,
                isOutOfStock: false,
                productID: null
            };
        },
    },
});


export const { 
    setSelectedSize,
    clearSelectedSize,
    setSelectedProduct, 
    // clearSelectedProduct, 
    setSelectedProductToAddQty,
    clearSelectedProductToAddQty,
    setPopulateNewProduct,
    updateNewProduct,
    resetNewProduct,
    toggleAddOn
} = userSlice.actions;
export default userSlice.reducer;

// export const selectCurrentProduct = (state: RootState) => state.product.selectedProduct;
// export const selectCurrentProductId = (state: RootState) => state.product.selectedProduct?.productID;

// export const selectCurrentProduct = (state: RootState) => state.product.newProduct.productName;
export const selectCurrentProductId = (state: RootState) => state.product.newProduct.productID;
export const selectCurrentProduct = (state: RootState): Product => ({
    productID: state.product.newProduct.productID ?? 0,
    productName: state.product.newProduct.productName,
    price: state.product.newProduct.price,
    sizeInfo: {
        size: state.product.newProduct.size?.label ?? '',
        sizeId: state.product.newProduct.size?.id ?? 0,
    },
    image: state.product.newProduct.image,
    isAvailable: state.product.newProduct.isAvailable,
    categoryInfo: {
        categoryId: state.product.newProduct.category?.id ?? 0,
        categoryName: state.product.newProduct.category?.label ?? ''
    },
    description: state.product.newProduct.description,
    sizeId: state.product.newProduct.size?.id ?? 0
});
export const selectNewProduct = (state: RootState) => state.product.newProduct;
export const selectNewProductSize = (state: RootState) => state.product.newProduct.size;
export const selectNewProductAddOns = (state: RootState) => state.product.newProduct.addOns;
export const selectNewProductType = (state: RootState) => state.product.newProduct.type;
export const selectNewProductCategory = (state: RootState) => state.product.newProduct.category;
export const selectNewProductCategoryName = (state: RootState) => state.product.newProduct.category?.label;
export const selectNewProductCategoryId = (state: RootState) => state.product.newProduct.category?.id;
export const selectCurrentProductToAddQty = (state: RootState) => state.product.selectedProductToAddQty;

export const selectedSizeFilter = (state: RootState) => state.product.selectedSize;
export const selectedSizeNameFilter = (state: RootState) => state.product.selectedSize.name;
export const selectedSizeIdFilter = (state: RootState) => state.product.selectedSize?.id;